import { Row as GridRow } from 'components/GridSystem';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.purple10};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 100%;
    min-height: 100vh;

    @media (max-width: 993px) {
      font-size: 3.6rem;
      line-height: 4.6rem;
    }
  `};
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark100};
    font-weight: 700;
    font-size: 3.6rem;
    line-height: 4.6rem;
    margin-bottom: 0;

    span {
      font-size: 2.4rem;
    }
  `};
`;

export const Image = styled.img`
  max-width: 456px;
  max-height: 468px;

  width: 100%;
  height: 100%;

  text-align: center;

  object-fit: contain;
`;

export const Row = styled(GridRow)`
  height: 100%;

  padding: 48px 0;

  @media (max-width: 993px) {
    padding: 16px 0;
  }
`;

export const HeaderSection = styled.section``;

export const FooterSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (min-width: 993px) {
    align-items: center;
  }
`;
